module.exports = __webpack_public_path__ + "img/yc.af070a31.png";